module.exports = __webpack_public_path__ + "img/tgg-4.29fd414e.webp";